import { Skeleton, Stack } from '@mantine/core';

export const PendingPage = () => {
  return (
    <Stack gap="sm" p="md">
      <Skeleton height={28} width="60%" />
      <Skeleton height={88} />
      <Skeleton height={88} />
      <Skeleton height={88} />
    </Stack>
  );
};

export default PendingPage;
